export default function ComparisonTable() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
          Mulebuy Spreadsheet vs Other Shopping Methods
        </h2>
        <p className="mt-3 text-sm text-foreground-600 max-w-xl">
          A transparent comparison of how the Mulebuy spreadsheet system stacks up against traditional shopping and other agent platforms.
        </p>

        <div className="mt-10 overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b-2 border-background-300">
                <th className="py-4 pr-6 text-sm font-semibold text-foreground-950">Feature</th>
                <th className="py-4 px-4 text-sm font-semibold text-primary-600 bg-primary-50/50 rounded-t-lg">
                  Mulebuy Spreadsheet
                </th>
                <th className="py-4 px-4 text-sm font-semibold text-foreground-700">Traditional Shopping</th>
                <th className="py-4 pl-4 text-sm font-semibold text-foreground-700">Other Platforms</th>
              </tr>
            </thead>
            <tbody className="text-sm text-foreground-700">
              {[
                { feature: "Price Transparency", mulebuy: "High", traditional: "Medium", others: "Low" },
                { feature: "Product Organization", mulebuy: "Structured Spreadsheet", traditional: "Scattered Pages", others: "Basic Listings" },
                { feature: "Category Coverage", mulebuy: "14 Categories", traditional: "Varies", others: "Limited" },
                { feature: "Ease of Comparison", mulebuy: "Excellent", traditional: "Moderate", others: "Difficult" },
                { feature: "Tracking System", mulebuy: "Spreadsheet-Based", traditional: "Limited", others: "Partial" },
                { feature: "Shopping Efficiency", mulebuy: "High", traditional: "Medium", others: "Low" },
              ].map((row) => (
                <tr key={row.feature} className="border-b border-background-200/70 hover:bg-background-100/50 transition-colors">
                  <td className="py-3.5 pr-6 font-medium text-foreground-800">{row.feature}</td>
                  <td className="py-3.5 px-4 text-primary-700 font-medium bg-primary-50/20">
                    {row.mulebuy}
                  </td>
                  <td className="py-3.5 px-4">{row.traditional}</td>
                  <td className="py-3.5 pl-4">{row.others}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="mt-8 text-sm text-foreground-600 max-w-2xl leading-relaxed">
          The <strong>Mulebuy spreadsheet system</strong> provides a more structured and efficient way to manage product selection and tracking compared to traditional methods. With transparent pricing across 14 distinct categories and a spreadsheet-based organizational approach, it eliminates the guesswork from online shopping.
        </p>
      </div>
    </section>
  );
}